(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-new-arrivals-template"]) return;
  try {
    									
	$('#paginateBy').on('change', function()
	{
    	var val = $(this).val();
                                                        /* Send the value as a cart attribute via the AJAX API */
    	$.ajax(
		{
    		type: "POST",
    		url: '/cart.js',
    		data: 
			{
				"attributes[pagination]": val
			}, 

    		success: function(d)
			{
				window.location.replace('?page=1');
			},

			dataType: 'json'
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    									
	$('#paginateBy').on('change', function()
	{
    	var val = $(this).val();
                                                        /* Send the value as a cart attribute via the AJAX API */
    	$.ajax(
		{
    		type: "POST",
    		url: '/cart.js',
    		data: 
			{
				"attributes[pagination]": val
			}, 

    		success: function(d)
			{
				window.location.replace('?page=1');
			},

			dataType: 'json'
		});
	});

  } catch(e) { console.error(e); }
})();
})();
